module.exports = __webpack_public_path__ + "media/flags/gb-flag-12c61058.svg";